var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('qb-stacked-snackbar'),_c('web3-modal-vue',{ref:"Web3ModalComponent",attrs:{"theme":_vm.web3ModalTheme,"provider-options":_vm.web3ModalProviderOptions,"cache-provider":""}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }